(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goldfish-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-kc-goldfish]').forEach(function (root) {
      if (root.dataset.kcGoldfishInit === '1') return;
      root.dataset.kcGoldfishInit = '1';

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /*-------- COUNTDOWN --------*/
      var cd = root.querySelector('[data-kc-countdown]');
      var tvCta = root.querySelector('[data-kc-tv-cta]');
      var tvClip = root.querySelector('[data-kc-tv-clip]');
      var targetStr = root.getAttribute('data-countdown-target');
      var target = targetStr ? new Date(targetStr).getTime() : NaN;
      var els = cd ? {
        d: cd.querySelector('[data-days]'), h: cd.querySelector('[data-hrs]'),
        m: cd.querySelector('[data-min]'), s: cd.querySelector('[data-sec]')
      } : null;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var expired = false;

      function toVideoState() {
        if (expired) return;
        expired = true;
        if (cd) cd.hidden = true;
        if (tvCta) tvCta.classList.add('is-live');
        if (tvClip) {
          tvClip.hidden = false;
          try { tvClip.play(); } catch (e) {}
        }
      }

      /*-------- FIT TV LAYERS TO THEIR QUADS (matrix3d homography) --------*/
      // Warp a flat element onto four scene-fraction corners so it sits flush on
      // the angled glass. The CTA uses the (smaller) text quad; the video
      // thumbnail uses the wider glass quad so it fills the whole screen.
      (function () {
        var stage = root.querySelector('.kc-goldfish__stage');
        if (!stage) return;
        var tvThumbEl = root.querySelector('[data-kc-tv-thumb]');

        function parseQuad(el, attr) {
          if (!el) return null;
          var q = (el.getAttribute(attr) || '').split(',').map(parseFloat);
          return (q.length >= 8 && !q.some(isNaN)) ? q : null;
        }
        function adj(m) { return [
          m[4]*m[8]-m[5]*m[7], m[2]*m[7]-m[1]*m[8], m[1]*m[5]-m[2]*m[4],
          m[5]*m[6]-m[3]*m[8], m[0]*m[8]-m[2]*m[6], m[2]*m[3]-m[0]*m[5],
          m[3]*m[7]-m[4]*m[6], m[1]*m[6]-m[0]*m[7], m[0]*m[4]-m[1]*m[3]
        ]; }
        function mmul(a, b) { var c = []; for (var i = 0; i < 3; i++) for (var j = 0; j < 3; j++) { var s = 0; for (var k = 0; k < 3; k++) s += a[3*i+k]*b[3*k+j]; c[3*i+j] = s; } return c; }
        function mvec(m, v) { return [ m[0]*v[0]+m[1]*v[1]+m[2]*v[2], m[3]*v[0]+m[4]*v[1]+m[5]*v[2], m[6]*v[0]+m[7]*v[1]+m[8]*v[2] ]; }
        function basis(x1,y1,x2,y2,x3,y3,x4,y4) { var m = [x1,x2,x3, y1,y2,y3, 1,1,1]; var v = mvec(adj(m), [x4,y4,1]); return mmul(m, [v[0],0,0, 0,v[1],0, 0,0,v[2]]); }
        function project(s, d) { return mmul(basis(d[0],d[1],d[2],d[3],d[4],d[5],d[6],d[7]), adj(basis(s[0],s[1],s[2],s[3],s[4],s[5],s[6],s[7]))); }

        function clearWarp(el) { if (!el) return; el.style.left = ''; el.style.top = ''; el.style.width = ''; el.style.height = ''; el.style.transform = ''; }

        // Warp `el` so its box corners land on the four scene-fraction corners.
        function warp(el, quad, sw, sh) {
          if (!el || !quad) return;
          var P = [[quad[0]*sw,quad[1]*sh],[quad[2]*sw,quad[3]*sh],[quad[4]*sw,quad[5]*sh],[quad[6]*sw,quad[7]*sh]]; // TL,TR,BR,BL
          var xs = [P[0][0],P[1][0],P[2][0],P[3][0]], ys = [P[0][1],P[1][1],P[2][1],P[3][1]];
          var minX = Math.min.apply(null, xs), minY = Math.min.apply(null, ys);
          var w = Math.max.apply(null, xs) - minX, h = Math.max.apply(null, ys) - minY;
          if (w <= 0 || h <= 0) return;
          el.style.left = minX + 'px'; el.style.top = minY + 'px';
          el.style.width = w + 'px'; el.style.height = h + 'px';
          // source box corners (0,0)(w,0)(0,h)(w,h) -> dest TL,TR,BL,BR relative to box origin
          var t = project(
            [0,0, w,0, 0,h, w,h],
            [P[0][0]-minX,P[0][1]-minY, P[1][0]-minX,P[1][1]-minY, P[3][0]-minX,P[3][1]-minY, P[2][0]-minX,P[2][1]-minY]
          );
          for (var i = 0; i < 9; i++) t[i] = t[i] / t[8];
          var mat = [t[0],t[3],0,t[6], t[1],t[4],0,t[7], 0,0,1,0, t[2],t[5],0,t[8]];
          el.style.transform = 'matrix3d(' + mat.join(',') + ')';
        }

        var tvQuad = parseQuad(tvCta, 'data-kc-tv-quad');
        var glassQuad = parseQuad(tvThumbEl, 'data-kc-tv-glass-quad');

        function fitTv() {
          // On mobile the countdown is a top banner (CSS), not warped onto the TV.
          if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
            clearWarp(tvCta); clearWarp(tvThumbEl);
            return;
          }
          var sw = stage.clientWidth, sh = stage.clientHeight;
          if (!sw || !sh) return;
          warp(tvCta, tvQuad, sw, sh);
          warp(tvThumbEl, glassQuad, sw, sh);
        }

        fitTv();
        requestAnimationFrame(fitTv);
        window.addEventListener('load', fitTv);
        if (window.ResizeObserver) { new ResizeObserver(fitTv).observe(stage); }
        else window.addEventListener('resize', fitTv);
      })();

      function tick() {
        if (isNaN(target) || !els) return;
        var diff = target - Date.now();
        if (diff <= 0) { els.d.textContent = els.h.textContent = els.m.textContent = els.s.textContent = '00'; toVideoState(); return; }
        var sec = Math.floor(diff / 1000);
        els.d.textContent = pad(Math.floor(sec / 86400));
        els.h.textContent = pad(Math.floor((sec % 86400) / 3600));
        els.m.textContent = pad(Math.floor((sec % 3600) / 60));
        els.s.textContent = pad(sec % 60);
      }
      if (!isNaN(target) && els) { tick(); setInterval(tick, 1000); }

      // Editor preview: force the post-countdown state so the announcement and the
      // clickable video link can be previewed without waiting for the target date.
      // Toggle "Preview expired state" in the section settings to use it.
      if (root.getAttribute('data-expiry-preview') === '1') { toVideoState(); }

      /*-------- MEDIA MODALS (reuse the site's shared lightbox) --------*/
      function parseYouTubeId(v) {
        if (!v) return '';
        v = v.trim();
        if (/^[\w-]{11}$/.test(v)) return v;
        var m = v.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/);
        return m ? m[1] : '';
      }
      var ytId = parseYouTubeId(root.getAttribute('data-youtube'));

      // Wire the CRT thumbnail to the YouTube id (desktop hover preview). Marking
      // the TV `has-thumb` is what enables the hover swap; without an id hover
      // leaves the announcement alone.
      var tvThumb = root.querySelector('[data-kc-tv-thumb]');
      var tvThumbImg = root.querySelector('[data-kc-tv-thumb-img]');
      if (tvThumb && tvThumbImg && ytId) {
        // Prefer a true 16:9 still. hqdefault.jpg is 4:3 with black bars baked in,
        // which fills the screen with letterbox instead of picture. maxres/hq720 are
        // real 16:9 but do not exist for every video, so fall down the list on 404
        // and only give up (dropping the hover preview) once nothing is left.
        // All three are true 16:9. hqdefault/sddefault are 4:3 with the picture
        // letterboxed inside them, which fills the tube with black bars instead
        // of picture. mqdefault is only 320x180 but always exists, and the TV
        // renders small enough that it holds up.
        var thumbSizes = ['maxresdefault', 'hq720', 'mqdefault'], thumbAt = 0;
        tvThumbImg.addEventListener('error', function () {
          thumbAt++;
          if (thumbAt < thumbSizes.length) {
            tvThumbImg.src = 'https://i.ytimg.com/vi/' + ytId + '/' + thumbSizes[thumbAt] + '.jpg';
            return;
          }
          if (tvCta) tvCta.classList.remove('has-thumb');
          tvThumb.hidden = true;
        });
        // Black bars can live INSIDE the still as well as around it: a cinemascope
        // video gives a true 16:9 maxresdefault whose picture is only ~68% of its
        // height. Comparing file dimensions cannot see that, so measure the actual
        // pixels and zoom past whatever bars are there. A 16:9 video measures 1.0
        // and gets left alone.
        function fitThumbToPicture(url) {
          var probe = new Image();
          probe.crossOrigin = 'anonymous';
          probe.onload = function () {
            try {
              var w = probe.naturalWidth, h = probe.naturalHeight;
              if (!w || !h) return;
              var c = document.createElement('canvas');
              c.width = w; c.height = h;
              var g = c.getContext('2d');
              g.drawImage(probe, 0, 0);
              var data = g.getImageData(0, 0, w, h).data;
              function rowLum(y) {
                var s = 0, n = 0;
                for (var x = 0; x < w; x += 8) { var i = (y * w + x) * 4; s += (data[i] + data[i+1] + data[i+2]) / 3; n++; }
                return s / n;
              }
              var top = 0, bot = h - 1;
              while (top < h && rowLum(top) < 14) top++;
              while (bot > top && rowLum(bot) < 14) bot--;
              var frac = (bot - top + 1) / h;
              if (!(frac > 0.25 && frac < 0.985)) return;
              // Cap the zoom: past this the horizontal crop takes more of the shot
              // than the bars were costing.
              var zoom = Math.min(1 / frac, 1.75);
              // Bars are rarely equal, so recentre on the picture. translate is
              // applied before scale, so this offset is in unscaled units.
              var shift = (0.5 - (top + bot + 1) / (2 * h)) * 100;
              tvThumbImg.style.translate = '0 ' + shift.toFixed(3) + '%';
              tvThumbImg.style.scale = zoom.toFixed(4);
            } catch (e) { /* tainted canvas: leave the still as-is */ }
          };
          probe.src = url;
        }
        tvThumbImg.addEventListener('load', function () {
          fitThumbToPicture(tvThumbImg.currentSrc || tvThumbImg.src);
        });
        tvThumbImg.src = 'https://i.ytimg.com/vi/' + ytId + '/' + thumbSizes[0] + '.jpg';
        tvThumb.hidden = false;
        if (tvCta) tvCta.classList.add('has-thumb');
      }

      var nameEl = root.querySelector('.kc-goldfish__tv-name');
      var videoTitle = (nameEl && nameEl.textContent.trim()) || 'Goldfish';

      function openVideo() {
        // Only interactive once the countdown has reached its expiry state.
        if (tvCta && !tvCta.classList.contains('is-live')) return;
        if (window.KCMediaLightbox && ytId) {
          // Keep the modal's top title, but no "· video" caption (label '' + captionType false).
          window.KCMediaLightbox.open([{ kind: 'v', ytid: ytId, label: '' }], 0, { title: videoTitle, captionType: false });
        } else if (ytId) {
          window.open('https://www.youtube.com/watch?v=' + ytId, '_blank', 'noopener');
        }
      }
      if (tvCta) tvCta.addEventListener('click', openVideo);

      /*-------- POLAROID GALLERY --------*/
      var photos = [];
      var dataEl = root.querySelector('[data-kc-gallery-data]');
      if (dataEl) { try { photos = JSON.parse(dataEl.textContent) || []; } catch (e) { photos = []; } }

      function openGallery(index) {
        if (!photos.length) return;
        if (window.KCMediaLightbox) {
          var items = photos.map(function (p) { return { kind: 'p', src: p.src, thumb: p.thumb, label: p.label || '' }; });
          // No title and no "photo" type caption; per-item labels still show if set.
          window.KCMediaLightbox.open(items, index || 0, { title: '', captionType: false });
        } else {
          window.open(photos[index || 0].src, '_blank', 'noopener');
        }
      }
      root.querySelectorAll('[data-kc-gallery-open]').forEach(function (btn) {
        btn.addEventListener('click', function () { openGallery(parseInt(btn.getAttribute('data-kc-gallery-open'), 10) || 0); });
      });

      /*-------- BUBBLES --------*/
      var layer = root.querySelector('[data-kc-bubbles]');
      var layerFront = root.querySelector('[data-kc-bubbles-front]') || layer;
      // ~45% of bubbles spawn behind the building, the rest in front, for depth.
      // Breakpoint is read live (mq.matches) at spawn time so a window resize
      // between mobile and desktop takes effect immediately. On desktop ~45% of
      // bubbles pass behind the building for depth; on mobile they all stay in
      // front so none float behind the SSM building.
      var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
      function bubbleLayer() { return (!mq.matches && Math.random() < 0.45) ? layer : layerFront; }
      if (layer && !reduce) {
        var rate = parseInt(root.getAttribute('data-bubble-rate'), 10) || 900;
        // Reflection glint pointing toward the light source = centre-top of the
        // screen (50%, 0%), where the rays come down. The glint sits on the side
        // of the bubble facing that source, and shifts as the bubble rises
        // (start position at the bottom, end near the top).
        function makeGlint(bxNum) {
          var g = document.createElement('span');
          g.className = 'kc-goldfish__bubble-glint';
          function pos(by) {
            var dx = 50 - bxNum, dy = -by, n = Math.sqrt(dx * dx + dy * dy) || 1, amp = 28;
            return [50 + amp * dx / n, 50 + amp * dy / n];
          }
          var a = pos(100), b = pos(2);
          g.style.setProperty('--hx0', a[0].toFixed(0) + '%');
          g.style.setProperty('--hy0', a[1].toFixed(0) + '%');
          g.style.setProperty('--hx1', b[0].toFixed(0) + '%');
          g.style.setProperty('--hy1', b[1].toFixed(0) + '%');
          return g;
        }
        function spawn() {
          var b = document.createElement('span');
          b.className = 'kc-goldfish__bubble';
          var mob = mq.matches;
          var durMul = mob ? 1.7 : 1;
          // Mostly small, but ~1 in 4 is a big drifting bubble like the artwork's.
          var big = Math.random() < 0.26;
          // Big drifting bubbles are smaller on mobile so they don't dominate.
          var size = big
            ? (mob ? 8 + Math.random() * 9 : 30 + Math.random() * 38)
            : (6 + Math.random() * 13);
          var bxNum = Math.random() * 100;
          b.style.setProperty('--bx', bxNum.toFixed(1) + '%');
          b.style.setProperty('--bs', size.toFixed(0) + 'px');
          b.style.setProperty('--bd', ((5 + Math.random() * 6) * durMul).toFixed(1) + 's');
          b.style.setProperty('--bdx', (Math.random() * 40 - 20).toFixed(0) + 'px');
          if (big) {
            // Near the front: crisp and more opaque.
            b.style.setProperty('--bo', (0.74 + Math.random() * 0.22).toFixed(2));
          } else {
            // Further back: fainter and softly blurred for depth of field.
            b.style.setProperty('--bo', (0.40 + Math.random() * 0.26).toFixed(2));
            b.style.setProperty('--blur', (0.6 + Math.random() * 1.7).toFixed(1) + 'px');
          }
          b.style.setProperty('--wob', (1.2 + Math.random() * 1.6).toFixed(2) + 's');
          b.appendChild(makeGlint(bxNum));
          b.addEventListener('animationend', function (e) { if (e.animationName === 'kc-gf-bubble') b.remove(); });
          bubbleLayer().appendChild(b);
        }
        // Bubble density: longer gaps between releases = fewer bubbles on screen.
        // Desktop shows about half as many as the raw rate, mobile about a quarter.
        (function loop() {
          var mob = mq.matches;
          var densityMul = mob ? 5 : 2;
          var burst = (!mob && Math.random() < 0.15) ? 3 : 1;
          for (var i = 0; i < burst; i++) setTimeout(spawn, i * 180);
          setTimeout(loop, rate * (0.5 + Math.random()) * densityMul);
        })();

        // Streams: steady columns of small bubbles rising from fixed x positions,
        // matching the painted streams in the artwork.
        var streamsAttr = root.getAttribute('data-bubble-streams');
        if (streamsAttr) {
          streamsAttr.split(',').forEach(function (raw, idx) {
            var baseX = parseFloat(raw);
            if (isNaN(baseX)) return;
            function streamBubble() {
              var b = document.createElement('span');
              b.className = 'kc-goldfish__bubble';
              var durMul = mq.matches ? 1.7 : 1;
              var size = 4 + Math.random() * 6;                 // smaller than ambient
              var jitter = (Math.random() * 3 - 1.5).toFixed(2); // tight column
              var bxNum = baseX + parseFloat(jitter);
              b.style.setProperty('--bx', bxNum.toFixed(2) + '%');
              b.style.setProperty('--bs', size.toFixed(0) + 'px');
              b.style.setProperty('--bd', ((13 + Math.random() * 6) * durMul).toFixed(1) + 's'); // slow rise
              b.style.setProperty('--bdx', (Math.random() * 12 - 6).toFixed(0) + 'px');
              b.style.setProperty('--bo', (0.42 + Math.random() * 0.26).toFixed(2));
              // Small stream bubbles sit in the back, so give them a soft blur.
              b.style.setProperty('--blur', (0.7 + Math.random() * 1.4).toFixed(1) + 'px');
              b.style.setProperty('--wob', (1.3 + Math.random() * 1.6).toFixed(2) + 's');
              b.appendChild(makeGlint(bxNum));
              b.addEventListener('animationend', function (e) { if (e.animationName === 'kc-gf-bubble') b.remove(); });
              bubbleLayer().appendChild(b);
            }
            (function streamLoop() {
              var mob = mq.matches;
              var durMul = mob ? 1.7 : 1;
              var densityMul = mob ? 5 : 2;
              // Mobile: a sparse few columns. Desktop: every other column.
              var active = mob ? (idx % 4 === 1) : (idx % 2 === 0);
              if (active) streamBubble();
              setTimeout(streamLoop, (450 + Math.random() * 750) * durMul * densityMul);
            })();
          });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-arcade"] && !Shopify.designMode) return;
  try {
    
  /*-------- KC ARCADE — launch, exit, and the Klaviyo hand-off --------*/
  (function () {
    'use strict';

    var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
    var KLAVIYO_REVISION = '2024-10-15';

    function init(root) {
      if (root.dataset.kcArcadeReady) return;
      root.dataset.kcArcadeReady = 'true';

      var overlays = root.querySelectorAll('[data-kc-arcade-game]');
      if (!overlays.length) return;

      var primaryKey = root.dataset.gameKey || 'burnmyboat';

      /* Every game this section knows about, keyed the way the game names
         itself: the same string it puts in its postMessage payloads and the
         same one that appears in a ?game= share link. */
      var configs = {};
      configs[primaryKey] = {
        url: root.dataset.gameUrl,
        origin: root.dataset.gameOrigin
      };
      if (root.dataset.game2Url) {
        configs[root.dataset.game2Key || 'carryon'] = {
          url: root.dataset.game2Url,
          origin: root.dataset.game2Origin
        };
      }

      var games = [];
      var byKey = {};
      var current = null;
      var lastFocus = null;

      /* One game's worth of machinery: its own frame, its own prewarm, its own
         origin. At most one is open, which `current` enforces. */
      function createGame(key, cfg, overlay, iframe) {
        var origin = resolveOrigin(cfg.origin, cfg.url);
        var exitBtn = overlay.querySelector('[data-kc-arcade-exit]');
        var warmed = false;
        var api;

        /* Boot the game before the click lands. It sits in a hidden,
           zero-opacity box, so three.js compiles and the first frames
           composite while the room is still being looked at. Without this the
           first launch stalls on a cold WebGL boot.

           The params are built onto a local copy rather than onto the stored
           URL. Closing resets `warmed`, so mutating the stored URL would
           append a second copy of every param on the next launch. */
        function prewarm() {
          if (warmed || !cfg.url) return;
          warmed = true;

          var url = cfg.url;
          var params = new URLSearchParams(window.location.search);

          /* Forward share-link attribution into the game, whichever game is
             opened. A score share from inside a game arrives as by= plus that
             game's own metric (mi for Burn My Boat, pts for Carry On). A share
             of the arcade page itself arrives already in the game's own
             vocabulary, ref=share&via=NAME, so both spellings of the credit
             are accepted here and only one is ever sent on.

             Guarded so a normal visit never gains an empty ref or via. */
          var via = params.get('by') || params.get('via');
          if (via || params.has('mi') || params.has('pts') || params.get('ref') === 'share') {
            url += (url.indexOf('?') > -1 ? '&' : '?') + 'ref=share'
              + (via ? '&via=' + encodeURIComponent(via) : '');
          }

          /* Where the game's own X should send fans when it closes the
             takeover. Read off the live URL rather than hardcoded, so it is
             right on production, on the myshopify domain and inside a preview
             theme, where the preview_theme_id params have to survive the trip.
             Share params come off so the return does not re-fire attribution,
             and the hash goes so it cannot land back on a play hash and
             reopen the game.

             The game only honours kennychesney.com addresses, so on a preview
             host it falls back to its own default. That is expected, not a
             misconfiguration. */
          try {
            var exitUrl = new URL(window.location.href);
            exitUrl.hash = '';
            exitUrl.searchParams.delete('by');
            exitUrl.searchParams.delete('mi');
            exitUrl.searchParams.delete('pts');
            exitUrl.searchParams.delete('game');
            exitUrl.searchParams.delete('ref');
            exitUrl.searchParams.delete('via');
            url += (url.indexOf('?') > -1 ? '&' : '?')
              + 'exit=' + encodeURIComponent(exitUrl.toString());
          } catch (_) { /* fail-soft: the game falls back to its own default */ }

          iframe.src = url;
        }

        /* Announce the host to the game. Its own back control posts to
           window.location.origin, which the browser refuses to deliver when the
           parent is a different site, so the button renders dead. The host
           origin cannot be hardcoded on their side: it differs per store, per
           Shopify preview theme and per custom domain. This gives them one to
           answer to. Sent on frame load and again on open, since the frame is
           pre-warmed and may boot before their listener is attached. */
        function greet() {
          if (!origin || !iframe.contentWindow) return;
          try {
            iframe.contentWindow.postMessage(
              { source: 'kc-arcade-host', type: 'hello' },
              origin
            );
          } catch (_) { /* fail-soft */ }
        }

        iframe.addEventListener('load', greet);

        /* fromHistory: the browser moved us here, so do not push another entry. */
        function open(fromHistory) {
          if (current === api) return;

          /* Switching straight from one game to the other. Drop the first
             without touching history: the entry we are moving to is already
             the right one. */
          if (current) current.close(true);

          current = api;
          lastFocus = document.activeElement;
          prewarm();

          /* Give the game its own history entry so Back closes it instead of
             leaving the site, and so the URL matches the one score shares use. */
          if (!fromHistory) {
            try {
              history.pushState({ kcArcade: 1, kcGame: key }, '', hashFor(key));
            } catch (_) { /* fail-soft */ }
          }

          /* Move to <body> so nothing in the section's ancestry can clip it. */
          if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
          overlay.hidden = false;
          void overlay.offsetWidth;
          overlay.classList.add('kc-arcade__game--on');
          document.documentElement.classList.add('kc-arcade-locked');
          document.body.classList.add('kc-arcade-locked');
          root.dispatchEvent(new CustomEvent('kc-arcade:game', { detail: { open: true, game: key } }));
          greet();
          if (exitBtn) exitBtn.focus({ preventScroll: true });
          else iframe.focus({ preventScroll: true });
        }

        function close(fromHistory) {
          if (current !== api) return;
          current = null;

          if (!fromHistory) {
            if (history.state && history.state.kcArcade) {
              try { history.back(); } catch (_) { /* fail-soft */ }
            } else {
              /* Opened by a plain link rather than by us, so there is no entry
                 of ours to go back to. Strip the hash instead: left in place,
                 clicking that same link again fires no hashchange and the game
                 never reopens. */
              clearPlayHash();
            }
          }

          overlay.classList.remove('kc-arcade__game--on');
          document.documentElement.classList.remove('kc-arcade-locked');
          document.body.classList.remove('kc-arcade-locked');
          root.dispatchEvent(new CustomEvent('kc-arcade:game', { detail: { open: false, game: key } }));

          window.setTimeout(function () {
            if (current === api) return;
            overlay.hidden = true;
            /* Drop the game so it stops consuming a WebGL context and audio in
               the background. The next launch re-warms from its launcher. */
            iframe.src = '';
            warmed = false;
          }, 300);

          if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
          lastFocus = null;
        }

        if (exitBtn) exitBtn.addEventListener('click', function () { close(); });

        api = {
          key: key,
          origin: origin,
          open: open,
          close: close,
          prewarm: prewarm,
          owns: function (src) { return src === iframe.contentWindow; }
        };
        return api;
      }

      Array.prototype.forEach.call(overlays, function (overlay) {
        var key = overlay.getAttribute('data-kc-arcade-game');
        var cfg = configs[key];
        var frame = overlay.querySelector('[data-kc-arcade-iframe]');
        if (!key || !cfg || !cfg.url || !frame) return;
        var made = createGame(key, cfg, overlay, frame);
        games.push(made);
        byKey[key] = made;
      });

      if (!games.length) return;

      /* The primary game keeps the bare #play it has always used, so existing
         score-share links and the Burn My Boat button keep working untouched.
         Every other game gets #play-<key>. */
      function hashFor(key) {
        return key === primaryKey ? '#play' : '#play-' + key;
      }

      function gameForHash() {
        var hash = window.location.hash;
        if (hash === '#play') {
          /* Score shares arrive as ?game=carryon&by=...&pts=...#play, so the
             query names the game and the hash only means "open one". */
          var wanted = new URLSearchParams(window.location.search).get('game');
          if (wanted && byKey[wanted]) return byKey[wanted];
          return byKey[primaryKey] || games[0];
        }
        if (hash.indexOf('#play-') === 0) return byKey[hash.slice(6)] || null;
        return null;
      }

      function clearPlayHash() {
        if (window.location.hash.indexOf('#play') !== 0) return;
        try {
          var url = new URL(window.location.href);
          url.hash = '';
          history.replaceState(history.state, '', url.toString());
        } catch (_) { /* fail-soft */ }
      }

      /* Launchers. The cabinet hotspot carries no value and means the primary
         game; anything else names its game. A Button block added in the theme
         editor has no data attribute at all and drives the same open through
         its #play-<key> href instead. */
      Array.prototype.forEach.call(root.querySelectorAll('[data-kc-arcade-launch]'), function (el) {
        var target = byKey[el.getAttribute('data-kc-arcade-launch') || primaryKey];
        if (!target) return;
        el.addEventListener('pointerenter', target.prewarm);
        el.addEventListener('focus', target.prewarm);
        el.addEventListener('click', function (ev) {
          /* Ours is a real link so it still works with no JS. Take the click
             back so the open is ours and Back closes the game rather than
             unwinding two entries. */
          if (el.tagName === 'A') ev.preventDefault();
          target.open();
        });
      });

      /* Only the primary game warms itself unprompted. Warming every game
         would boot a WebGL context per cabinet on a page nobody has clicked. */
      window.addEventListener('load', function () {
        if (!byKey[primaryKey]) return;
        window.setTimeout(byKey[primaryKey].prewarm, 1500);
      });

      window.addEventListener('popstate', function () {
        var target = gameForHash();
        if (target) target.open(true);
        else if (current) current.close(true);
      });

      window.addEventListener('hashchange', function () {
        var target = gameForHash();
        if (target) target.open(true);
      });

      /* Arriving on a shared link. The entry is already ours, so no push. */
      (function () {
        var target = gameForHash();
        if (target) target.open(true);
      })();

      /*-------- attract screen: the CRT alternating between the game's own
         picture and a high-score board, the way a cabinet on standby does --------*/
      var screenVideos = initScreenVideos(root);

      /* One ticker per cabinet. Each panel carries its own board in
         data-entries, so two cabinets can show different high scores and a
         third needs no JS change. */
      Array.prototype.forEach.call(root.querySelectorAll('[data-kc-arcade-attract]'), function (panel) {
        var ticker = panel.querySelector('[data-kc-arcade-ticker]');
        if (!ticker) return;

        var entries = (panel.getAttribute('data-entries') || root.dataset.attractEntries || '')
          .split('\n')
          .map(function (s) { return s.trim(); })
          .filter(Boolean);

        /* The typed board is the fallback, not the source of truth. If a
           leaderboard URL is set, the real top scores replace it as soon as
           they arrive; if the request fails the cabinet keeps showing the
           typed lines rather than going blank. */
        var scoresUrl = panel.getAttribute('data-scores-url');
        if (scoresUrl) loadScores(scoresUrl, panel, function (live) {
          if (live.length) { entries = live; i = 0; }
        });

        if (!entries.length && !scoresUrl) return;

        var onMs = parseInt(root.dataset.attractOn, 10) || 5000;
        var offMs = parseInt(root.dataset.attractOff, 10) || 5000;
        var i = 0;
        var timer = null;

        function show() {
          ticker.textContent = entries[i % entries.length];
          i++;
          panel.classList.add('kc-arcade__attract--on');
          timer = window.setTimeout(hide, onMs);
        }

        function hide() {
          panel.classList.remove('kc-arcade__attract--on');
          timer = window.setTimeout(show, offMs);
        }

        function stop() {
          window.clearTimeout(timer);
          timer = null;
          panel.classList.remove('kc-arcade__attract--on');
        }

        function start() {
          if (timer || current) return;
          timer = window.setTimeout(show, offMs);
        }

        /* Nothing animates while the game is up, while the tab is hidden, or
           while the section is off screen. An idle cabinet should not keep a
           backdrop-filter repainting behind a full-screen WebGL canvas. */
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) { stop(); screenVideos.pause(); } else { start(); screenVideos.play(); }
        });

        /* Start straight away rather than waiting to be told the section is
           visible. The observer below is only allowed to PAUSE and resume.
           Waiting on it meant the cabinets sat dead whenever the first
           callback was throttled or never delivered, which is exactly what
           happens in a background tab, and the hero is above the fold anyway. */
        start();
        screenVideos.play();

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (rows) {
            rows.forEach(function (row) {
              if (row.isIntersecting) { start(); screenVideos.play(); }
              else { stop(); screenVideos.pause(); }
            });
          }, { threshold: 0.01 }).observe(root);
        }

        root.addEventListener('kc-arcade:game', function (ev) {
          if (ev.detail && ev.detail.open) { stop(); screenVideos.pause(); }
          else { start(); screenVideos.play(); }
        });
      });

      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && current) current.close();
      });

      /* Their own exit, once it reaches us. Handled below in the message
         listener; kept here as the reason the exit button can be switched off
         rather than needing to be deleted. */

      /*-------- messages from the game --------*/
      /* Which game sent this is decided by the frame the message came from,
         not by what the message claims to be. Both games are served from the
         same origin, so origin alone cannot tell them apart. */
      window.addEventListener('message', function (ev) {
        var from = null;
        for (var i = 0; i < games.length; i++) {
          if (games[i].owns(ev.source)) { from = games[i]; break; }
        }
        if (!from) return;
        if (from.origin && ev.origin !== from.origin) return;

        var data = ev.data;
        if (!data || typeof data !== 'object') return;
        if (data.source !== from.key) return;

        if (data.type === 'exit') {
          /* Answer before closing, for two reasons: the game waits about half
             a second for this and otherwise navigates itself to the ?exit=
             address, and once close() empties the frame there is no
             contentWindow left to answer with. */
          try {
            ev.source.postMessage({ source: 'ssmarcade', type: 'exit-handled' }, ev.origin);
          } catch (_) { /* fail-soft */ }
          from.close();
        } else if (data.type === 'signup') {
          subscribe(data.payload || {});
        }
      });

      /*-------- Klaviyo — FALLBACK ONLY, normally inert --------*/
      /* The game writes to Klaviyo itself, so this must not fire as well: one
         signup filing two subscription calls would double the consent events
         on a single profile. It stays dead because the company id and list id
         are deliberately blank, and it bails on either being empty. Kept as a
         way back if the game ever stops owning the write. Public key only if
         it is ever filled in; no private key belongs in a browser. */
      function subscribe(payload) {
        var companyId = root.dataset.klaviyoCompany;
        var listId = root.dataset.klaviyoList;
        var email = (payload.email || '').trim();
        if (!companyId || !listId || !email) return;

        var props = {};
        if (payload.name) props.$first_name = payload.name;
        if (payload.phone) props.$phone_number = payload.phone;
        if (payload.birthday) props.Birthday = payload.birthday;
        if (payload.score != null) props.arcade_best_score = payload.score;
        if (payload.game) props.arcade_game = payload.game;
        props.arcade_signup_source = root.dataset.klaviyoSource || 'ssm-arcade';

        var profile = { type: 'profile', attributes: { email: email, properties: props } };
        if (payload.phone) profile.attributes.phone_number = payload.phone;

        fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: { 'content-type': 'application/json', revision: KLAVIYO_REVISION },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: { profile: { data: profile } },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        }).catch(function () { /* never let a list write break the game */ });
      }
    }

    /* One row of a leaderboard, as an arcade board line.

       The two games report different fields: Carry On sends a plain `score`,
       Burn My Boat sends `miles_tenths` (825 meaning 82.5 miles). Read
       whichever is present rather than configuring it per cabinet, so a third
       game only has to match one of the shapes. */
    function scoreLine(row) {
      var name = String(row && row.name || '').trim().toUpperCase().slice(0, 12);
      if (!name) return '';
      var score;
      if (typeof row.score === 'number') score = String(row.score);
      else if (typeof row.miles_tenths === 'number') score = (row.miles_tenths / 10).toFixed(1);
      else if (typeof row.points === 'number') score = String(row.points);
      else return '';
      return name + '  ' + score;
    }

    function loadScores(url, panel, done) {
      var count = parseInt(panel.getAttribute('data-scores-count'), 10) || 3;
      /* credentials omitted on purpose: these boards answer with a single
         allowed origin, and sending cookies would fail the CORS check. */
      fetch(url, { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var rows = (data && data.rows) || [];
          done(rows.slice(0, count).map(scoreLine).filter(Boolean));
        })
        .catch(function () { /* keep the typed board */ });
    }

    /* Screen footage. Deliberately conservative: no src until the hero is on
       screen, paused whenever it cannot be seen or a game is open over it, and
       never started at all for someone who asked for reduced motion. Two
       autoplaying videos in a hero is real weight, and none of it is content
       anyone came for. */
    function initScreenVideos(root) {
      var vids = root.querySelectorAll('[data-kc-arcade-screenvid]');
      if (!vids.length) return { play: function () {}, pause: function () {} };

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function play() {
        if (reduced) return;
        Array.prototype.forEach.call(vids, function (v) {
          if (!v.src) {
            v.src = v.getAttribute('data-src');
          }
          /* Older iOS wants the property as well as the attribute. */
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () { /* autoplay refused; the board still runs */ });
        });
      }

      function pause() {
        Array.prototype.forEach.call(vids, function (v) { if (!v.paused) v.pause(); });
      }

      return { play: play, pause: pause };
    }

    function resolveOrigin(explicit, url) {
      if (explicit) return explicit;
      if (!url) return '';
      try {
        return new URL(url, window.location.href).origin;
      } catch (_) {
        return '';
      }
    }

    /*-------- mobile: sizing the first machine to the fold --------*/
    /* The rule behind the stacked layout is that the fold must never land on a
       clean screen edge: the next machine's rail plus a sliver of its lit
       glass has to show, because that peek is the only thing on the page that
       says there is more below. The first screen's height is what produces it,
       and the right height depends on the phone AND on how much room the
       site's own header is taking that day, which announcement bars change
       without warning. So it is measured rather than assumed.

       CSS carries the approved 393x852 value as a default, so a render with
       no JS still lands within a few pixels. */
    function mountMobileFold(block) {
      if (!block || block.dataset.kcFoldReady) return;
      block.dataset.kcFoldReady = 'true';

      var header = block.querySelector('.kc-arcade__m-headerimg');
      if (!header) return;

      var STACK_INSET = 12;
      var GAP = 24;
      var PEEK = 50; /* 15px rail + 2px glass lip + 33px of lit picture */

      /* Guards against a bad measurement, not shaping tools: both are set wide
         enough that no real phone reaches them, because a clamp that bites is
         a clamp that eats the peek. 240 still leaves the fold in the wall gap
         on a 320x568 phone rather than on a screen edge, which is the last
         size where the room fits at all. */
      /* The PLAY GAME pill is 166px at its narrowest and lives inside the
         glass, so a machine under about 196px cannot contain its own control.
         That, not taste, is the floor. The only viewport that reaches it is a
         320x568 phone, where the fold lands on the next machine's rail rather
         than the 50px of glass everything else gets. */
      var MIN_WIDTH = 200;
      var lastWidth = -1;
      var screens = block.querySelectorAll('.kc-arcade__m-screen');

      function measure() {
        if (window.innerWidth > 749 || !screens.length) return;

        var glass = screens[0].querySelector('.kc-arcade__m-glass');
        if (!glass) return;

        var screenBox = screens[0].getBoundingClientRect();
        var glassBox = glass.getBoundingClientRect();
        if (!glassBox.height) return;

        /* The bezel rail and the glass shape, taken off the machine itself
           rather than restated from the CSS, so changing either one there
           cannot silently put this arithmetic out of step. Both are constant
           at any size, so measuring them at the current width is safe. */
        var bezel = screenBox.height - glassBox.height;
        var glassRatio = glassBox.width / glassBox.height;

        /* Whatever sits above the room. On the arcade page that is the utility
           bar and the nav; measured off the block's own document offset rather
           than by looking for a header element, which differs per template.

           Guarded, because this section also runs as a homepage hero: if the
           room is a long way down the page there is no chrome above it by the
           time anyone reaches it, and the offset would otherwise shrink the
           machines for no reason. */
        var docTop = block.getBoundingClientRect().top + window.pageYOffset;
        var chrome = docTop < window.innerHeight * 0.4 ? docTop : 0;
        var headerHeight = header.getBoundingClientRect().height;

        var wanted = window.innerHeight - chrome - headerHeight - STACK_INSET - GAP - PEEK;
        var width = (wanted - bezel) * glassRatio + bezel;

        /* Only ever a ceiling: max-width above what the wall allows is the
           same as no constraint, so a viewport with room to spare keeps the
           full-width machine and simply shows more of the next one. */
        block.style.setProperty(
          '--kc-m-screen-w',
          Math.max(MIN_WIDTH, Math.round(width)) + 'px'
        );
      }

      /* Width only. On a phone the address bar collapsing fires resize on
         every scroll, and remeasuring there would resize the machine under
         the reader's thumb. A width change is a rotation or a real reflow,
         which is the only time this needs to move. */
      function onResize() {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        measure();
      }

      onResize();
      window.addEventListener('resize', onResize);

      /* The artwork carries width and height attributes, so its box is known
         before it decodes; this is the belt to that braces, for the case where
         a swapped-in image has different proportions. */
      if (!header.complete) header.addEventListener('load', measure);
    }

    function boot() {
      document.querySelectorAll('[data-kc-arcade]').forEach(init);
      document.querySelectorAll('[data-kc-arcade-mobile]').forEach(mountMobileFold);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (ev) {
      var root = ev.target.querySelector('[data-kc-arcade]');
      if (root) init(root);
      var mobile = ev.target.querySelector('[data-kc-arcade-mobile]');
      if (mobile) mountMobileFold(mobile);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-article-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShopStory(root) {
      if (!root || root.dataset.kcInit) return;
      root.dataset.kcInit = '1';

      var teaser = root.querySelector('.kc-shop-story__teaser');
      if (!teaser) return;

      var target = document.querySelector('.kc-related-products');
      // No related-products row on the page -> the pill has nowhere to go.
      if (!target) {
        root.style.display = 'none';
        return;
      }

      teaser.addEventListener('click', function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // Tuck the pill away once the footer comes into view.
      var footer = document.querySelector('#footer-group, footer, .footer');
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              root.classList.toggle('kc-shop-story--hidden', entry.isIntersecting);
            });
          },
          { rootMargin: '0px' }
        ).observe(footer);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-kc-shop-story]').forEach(initShopStory);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-topbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.kc-topbar').forEach(function (root) {
      if (root.dataset.kcSectionInit === '1') return;
      root.dataset.kcSectionInit = '1';

      /*-------- ESCAPE THE HEADER-GROUP STACKING CONTEXT --------
         Detach from the header section wrapper and prepend directly to <body>
         so the bar can paint over the sticky header regardless of z-index. */
      if (root.parentElement !== document.body) {
        document.body.prepend(root);
      }

      /*-------- SCROLL SHADOW --------*/
      window.addEventListener('scroll', function () {
        root.classList.toggle('is-scrolled', window.scrollY > 8);
      }, { passive: true });

      /*-------- BODY OFFSET WHEN FIXED --------
         When the bar is fixed it leaves the flow, so push body content down
         by the bar's current height. Re-measured on every reflow. */
      if (root.classList.contains('kc-topbar--sticky')) {
        document.body.classList.add('has-kc-topbar');
        var setOffset = function () {
          document.body.style.setProperty('--kc-topbar-h', root.offsetHeight + 'px');
        };
        setOffset();
        if (window.ResizeObserver) {
          new ResizeObserver(setOffset).observe(root);
        } else {
          window.addEventListener('resize', setOffset);
        }
      }

      /*-------- BLOCK CAROUSEL --------
         With more blocks than fit (2 on desktop, 1 on mobile), slide them
         through. Auto-advances, pauses on hover/focus, loops seamlessly. */
      (function initCarousel() {
        var viewport = root.querySelector('[data-kc-viewport]');
        var track    = root.querySelector('[data-kc-track]');
        var dotsWrap = root.querySelector('[data-kc-dots]');
        if (!viewport || !track) return;

        var realSlides = Array.prototype.slice.call(track.children);
        var activeSlides = realSlides.slice();
        var N = activeSlides.length;
        var CLONES = 2; // max slides visible at once (desktop)

        var mqMobile    = window.matchMedia('(max-width: 749px)');
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        var rotateMs = (parseFloat(root.dataset.kcRotate) || 5) * 1000;

        var clones = [], index = 0, timer = null, paused = false;

        function visibleCount() { return mqMobile.matches ? 1 : 2; }

        function isMobileEnabled(slide) {
          var block = slide.querySelector('[data-kc-mobile-enabled]');
          return !block || block.dataset.kcMobileEnabled !== 'false';
        }

        function getActiveSlides() {
          if (!mqMobile.matches) return realSlides.slice();
          return realSlides.filter(isMobileEnabled);
        }

        // Hold position while the user is interacting: hovering/typing (paused)
        // or actively playing the song (root has .is-playing).
        function isHeld() { return paused || root.classList.contains('is-playing'); }

        function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
        function startAuto() {
          stopAuto();
          if (reduceMotion.matches) return;
          timer = setInterval(function () { if (!isHeld()) next(); }, rotateMs);
        }

        function teardown() {
          root.classList.remove('kc-topbar--carousel');
          clones.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); });
          clones = [];
          realSlides.forEach(function (s) {
            s.classList.remove('is-slide-left', 'is-slide-right', 'kc-topbar__slot--left', 'kc-topbar__slot--right');
            s.style.display = '';
          });
          if (dotsWrap) dotsWrap.innerHTML = '';
          track.style.transform = '';
          viewport.style.height = '';
          index = 0;
          stopAuto();
        }

        function apply(animate) {
          if (!activeSlides.length) return;
          var w = activeSlides[0].getBoundingClientRect().width;
          if (!animate) {
            track.classList.add('is-snapping');
            track.style.transform = 'translateX(' + (-index * w) + 'px)';
            void track.offsetWidth; // force reflow
            track.classList.remove('is-snapping');
          } else {
            track.style.transform = 'translateX(' + (-index * w) + 'px)';
          }
          updateAlignment();
        }

        function updateAlignment() {
          var items = activeSlides.concat(clones);
          for (var i = 0; i < items.length; i++) {
            items[i].classList.remove('is-slide-left', 'is-slide-right', 'kc-topbar__slot--left', 'kc-topbar__slot--right');
          }
          if (visibleCount() < 2) return; // mobile: single centered slide
          var leftEl = items[index], rightEl = items[index + 1];
          if (leftEl)  leftEl.classList.add('is-slide-left', 'kc-topbar__slot--left');
          if (rightEl) rightEl.classList.add('is-slide-right', 'kc-topbar__slot--right');
        }

        function updateDots() {
          if (!dotsWrap) return;
          var active = ((index % N) + N) % N;
          Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
            dot.classList.toggle('is-active', i === active);
          });
        }

        function goTo(i) { index = i; apply(true); updateDots(); }
        function next() { index++; apply(true); updateDots(); }

        track.addEventListener('transitionend', function (e) {
          if (e.propertyName !== 'transform') return;
          if (index >= N) { index -= N; apply(false); updateDots(); }
        });

        function build() {
          teardown();
          activeSlides = getActiveSlides();
          N = activeSlides.length;

          realSlides.forEach(function (slide) {
            slide.style.display = activeSlides.indexOf(slide) === -1 ? 'none' : '';
          });

          if (!N) {
            viewport.style.height = '0px';
            return;
          }

          if (N <= visibleCount()) return;

          root.classList.add('kc-topbar--carousel');

          for (var i = 0; i < Math.min(CLONES, N); i++) {
            var c = activeSlides[i].cloneNode(true);
            c.setAttribute('aria-hidden', 'true');
            c.dataset.kcClone = '1';
            c.style.pointerEvents = 'none';
            // Clones are visual only — never let a cloned player spin up audio.
            c.querySelectorAll('iframe').forEach(function (el) { el.remove(); });
            c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
            c.querySelectorAll('input, button, a, select, textarea, iframe').forEach(function (el) {
              el.setAttribute('tabindex', '-1');
              if ('disabled' in el) { try { el.disabled = true; } catch (e) {} }
            });
            track.appendChild(c);
            clones.push(c);
          }

          var maxH = 0;
          activeSlides.forEach(function (s) { maxH = Math.max(maxH, s.offsetHeight); });
          if (maxH > 0) viewport.style.height = maxH + 'px';

          if (dotsWrap) {
            dotsWrap.innerHTML = '';
            for (var d = 0; d < N; d++) {
              (function (d) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'kc-topbar__dot';
                b.setAttribute('aria-label', 'Show item ' + (d + 1));
                b.addEventListener('click', function () { goTo(d); startAuto(); });
                dotsWrap.appendChild(b);
              })(d);
            }
          }

          index = 0;
          apply(false);
          updateDots();
          startAuto();
        }

        root.addEventListener('mouseenter', function () { paused = true; });
        root.addEventListener('mouseleave', function () { paused = false; });
        root.addEventListener('focusin',  function () { paused = true; });
        root.addEventListener('focusout', function () { paused = false; });

        var rt;
        window.addEventListener('resize', function () {
          clearTimeout(rt);
          rt = setTimeout(build, 200);
        });

        build();
      })();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wave-divider"] && !Shopify.designMode) return;
  try {
    
  /*-------- WAVE DIVIDER (animated) --------
     Mirrors v4.html: 3-layer sine surface drifted by time + scroll velocity.
     One shared scroll listener + RAF loop drives every instance on the page. */
  (function () {
    var W = 1440, H = 100;
    var divs = document.querySelectorAll('.kc-wave');
    if (!divs.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function rngFromSeed(seed) {
      var s = (seed * 16807) % 2147483647;
      return function () {
        s = (s * 16807) % 2147483647;
        return s / 2147483647;
      };
    }

    var dividers = [];

    divs.forEach(function (div) {
      // Skip if already initialized (Shopify can re-render the same section)
      if (div.dataset.kcWaveReady === '1') return;
      div.dataset.kcWaveReady = '1';

      var seedIn = parseInt(div.dataset.seed, 10) || 1;
      var seed = seedIn * 9301 + Math.floor(Math.random() * 9999);
      var rand = rngFromSeed(seed);
      var topFill = div.dataset.topFill || 'transparent';
      var bottomFill = div.dataset.bottomFill || 'transparent';

      // Three sine layers — primary swell, counter-rhythm, fine surface texture.
      var layers = [
        { baseAmp: 4 + rand() * 2, idleAmp: 14 + rand() * 4, velAmp: 22,
          freq: 0.7 + rand() * 0.25, phase: rand() * Math.PI * 2,
          speed: 0.00018 + rand() * 0.00010 },
        { baseAmp: 2.5 + rand() * 1.5, idleAmp: 7 + rand() * 3, velAmp: 13,
          freq: 1.3 + rand() * 0.4, phase: rand() * Math.PI * 2,
          speed: 0.00040 + rand() * 0.00018 },
        { baseAmp: 1.2 + rand() * 0.8, idleAmp: 2.5 + rand() * 1.2, velAmp: 5,
          freq: 2.6 + rand() * 1.0, phase: rand() * Math.PI * 2,
          speed: 0.00080 + rand() * 0.00030 }
      ];

      div.innerHTML =
        '<svg viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path class="kc-wave__top" d="" fill="' + topFill + '"/>' +
        '<path class="kc-wave__bottom" d="" fill="' + bottomFill + '"/>' +
        '</svg>';

      var animate = div.dataset.animate === 'true';
      dividers.push({
        topPath: div.querySelector('.kc-wave__top'),
        bottomPath: div.querySelector('.kc-wave__bottom'),
        layers: layers,
        baseline: H * 0.5 + (rand() - 0.5) * 6,
        animate: animate && !reduceMotion
      });
    });

    function renderPaths(d, t, velocity) {
      var layers = d.layers, baseline = d.baseline, STEPS = 64;
      var isMobile = window.innerWidth <= 600;
      var isTablet = !isMobile && window.innerWidth <= 900;
      var ampScale = isMobile ? 0.8 : (isTablet ? 0.85 : 1);
      var freqScale = isMobile ? 0.55 : (isTablet ? 0.78 : 1);
      var velAmpScale = isMobile ? 0.8 : (isTablet ? 0.75 : 1);
      // Drift faster on mobile so the idle motion is visible without scrolling.
      var timeScale = isMobile ? 1.8 : (isTablet ? 1.3 : 1);

      var vAbs = Math.min(100, Math.abs(velocity));
      var vMag = Math.sqrt(vAbs / 100);
      var vDir = Math.sign(velocity);

      // On mobile, drop the scroll-inertia response: touch/momentum scroll velocity
      // is unreliable, so the velocity-driven waves flatten right when they're in
      // view. Zero it out so the idle waves stay at full amplitude and the time
      // drift animates them on its own (always wavy, no scrolling required).
      if (isMobile) {
        vMag = 0;
        vDir = 0;
        velocity = 0;
      }

      var pts = [];
      for (var i = 0; i <= STEPS; i++) {
        var x = (W / STEPS) * i;
        var u = x / W;
        var dev = 0;
        for (var j = 0; j < layers.length; j++) {
          var L = layers[j];
          var idle = (L.idleAmp || 0) * (1 - vMag);
          var driven = L.velAmp * vMag * velAmpScale;
          var amp = (L.baseAmp + idle + driven) * ampScale;
          var freq = L.freq * freqScale;
          var phaseShift = vDir * freq * vMag * 1.4;
          dev += Math.sin(u * Math.PI * 2 * freq + L.phase + t * L.speed * 1000 * timeScale + phaseShift) * amp;
        }
        dev += velocity * 0.05 * ampScale * (u - 0.5);
        // Soft-limit the excursion so a fast scroll rounds the crests off
        // instead of spiking them into sharp points. Idle/gentle waves stay
        // below the limit and pass through unchanged (so other dividers look
        // the same); only large velocity-driven spikes get compressed.
        var lim = 34 * ampScale;
        var ad = Math.abs(dev);
        if (ad > lim) dev = (dev < 0 ? -1 : 1) * (lim + (1 - Math.exp(-(ad - lim) / 12)) * 10);
        pts.push({ x: x, y: baseline + dev });
      }

      var curve = 'M0,' + pts[0].y.toFixed(2);
      for (var k = 0; k < pts.length - 1; k++) {
        var p0 = pts[Math.max(0, k - 1)];
        var p1 = pts[k];
        var p2 = pts[k + 1];
        var p3 = pts[Math.min(pts.length - 1, k + 2)];
        var t1x = p1.x + (p2.x - p0.x) / 6;
        var t1y = p1.y + (p2.y - p0.y) / 6;
        var t2x = p2.x - (p3.x - p1.x) / 6;
        var t2y = p2.y - (p3.y - p1.y) / 6;
        curve += ' C' + t1x.toFixed(2) + ',' + t1y.toFixed(2) + ' ' +
                 t2x.toFixed(2) + ',' + t2y.toFixed(2) + ' ' +
                 p2.x.toFixed(2) + ',' + p2.y.toFixed(2);
      }
      return {
        top: curve + ' L' + W + ',0 L0,0 Z',
        bottom: curve + ' L' + W + ',' + H + ' L0,' + H + ' Z'
      };
    }

    // Initial render so every divider has shape immediately.
    dividers.forEach(function (d) {
      var paths = renderPaths(d, 0, 0);
      d.topPath.setAttribute('d', paths.top);
      d.bottomPath.setAttribute('d', paths.bottom);
    });

    // Bail out of the loop if nothing wants animation.
    var anyAnimated = dividers.some(function (d) { return d.animate; });
    if (!anyAnimated) return;

    // Shared scroll-velocity tracking — single listener, one smoothed value.
    var lastY = window.scrollY, raw = 0, smooth = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      raw = y - lastY;
      lastY = y;
    }, { passive: true });

    var start = performance.now();
    function tick(now) {
      var t = (now - start) / 1000;
      smooth += (raw - smooth) * 0.08;
      raw *= 0.88;
      var v = Math.max(-200, Math.min(200, smooth));

      for (var i = 0; i < dividers.length; i++) {
        var d = dividers[i];
        if (!d.animate) continue;
        var svg = d.bottomPath.ownerSVGElement;
        var rect = svg.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > window.innerHeight + 100) continue;
        var paths = renderPaths(d, t, v);
        d.topPath.setAttribute('d', paths.top);
        d.bottomPath.setAttribute('d', paths.bottom);
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  } catch(e) { console.error(e); }
})();
})();
